<template>
  <div>
    <div
      v-show="isActive"
      ref="backDiv"
      id="back-div"
      class="back-overlay"
    ></div>
    <div
      id="drawer"
      class="drawer-overlay"
      :style="styles.pageColor"
      :class="{ active: isActive }"
    >
      <a class="clearfix">
        <span
          @click.prevent="$emit('closed')"
          class="material-icons overlay-close md-36"
          >close</span
        >
      </a>
      <div
        class="tc-login"
        :style="styles.pageColor"
        v-if="hqDoc && hqDoc.TermsAndConditions && showTermsAndConditions"
      >
        <h2>{{ $t("message.termsAndConditions") }}</h2>
        <div class="tc-content" v-html="hqDoc.TermsAndConditions"></div>
        <div class="mt-4 text-center">
          <button
            class="btn"
            :style="styles.btn"
            @click="showTermsAndConditions = false"
          >
            {{ $t("message.ok") }}
          </button>
        </div>
      </div>
      <template v-else>
        <sms-verification
          v-if="showVerification"
          @completed="close()"
          :userModel="userModel"
        />
        <login
          v-if="showLogin"
          :overlay-active="isActive"
          @toggleTC="showTermsAndConditions = true"
          @need-verification="needVerify"
          @close-overlay="close()"
        />
        <register
          v-if="showRegister"
          @toggleTC="showTermsAndConditions = true"
          @show-verification="needVerify"
          @close-overlay="close()"
        />
      </template>
    </div>
  </div>
</template>

<script>
import login from "../user/login.vue";
import register from "../user/register.vue";
import { $$ } from "./../../sharedscripts/OO_jquery";
import { mapActions, mapGetters } from "vuex";
import smsVerification from "../user/smsVerification.vue";

export default {
  components: {
    login,
    register,
    smsVerification,
  },
  name: "Overlay",
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      //0:login 1:verification 2:register
      // viewIndex: 0,
      verifiedNumber: "",
      userModel: null,
      showTermsAndConditions: false,
    };
  },

  computed: {
    ...mapGetters([
      "currentStoreDoc",
      "user",
      "redirectedFromCheckout",
      "styles",
      "getOverlayIndex",
      "hqDoc",
      "getOverlayIndex",
    ]),
    showLogin() {
      return this.getOverlayIndex === 0;
    },
    showVerification() {
      return this.getOverlayIndex === 1;
    },
    showRegister() {
      return this.getOverlayIndex === 2;
    },
  },
  watch: {
    isActive() {
      if (this.isActive) {
        this.setInitView();
        $$("body,html").addClass("draweractive");
      } else {
        $$("body,html").removeClass("draweractive");
      }
    },
  },
  mounted() {
    const that = this;
    if (this.$refs.backDiv) {
      this.$refs.backDiv.onclick = function() {
        if (that.isActive) {
          that.$emit("closed");
        }
      };
    }
      if (this.isActive) {
        this.isLogin = true;
        $$('body,html').addClass('draweractive');
      }else{
        $$('body,html').removeClass('draweractive');
      }
  },
  methods: {
    ...mapActions(["logout", "setOverlayIndex"]),
    close() {
      if (this.isActive) {
        this.$emit("closed");
        if (this.redirectedFromCheckout)
          this.$router.push({
            name: "checkout",
            params: { storename: this.currentStoreDoc.Name },
          });
      }
    },

    needVerify(user) {
      this.userModel = user;
      this.setOverlayIndex(1);
    },
    setInitView() {
      this.showTermsAndConditions = false;
      if (this.user) {
        this.userModel = {
          ...this.user,
          login: true,
          HQCompanyID: this.hqDoc.ID,
        };
        this.setOverlayIndex(1);
      } else {
        const index = this.getOverlayIndex || 0;
        this.setOverlayIndex(index);
      }
    },
  },
};
</script>
